import { Injectable } from '@angular/core';
import { FieldModel } from '../../model/myria/app/DynamicForm';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { HttpMapper } from './http-mapper';
import { APP_CONFIG } from '../../environment';

@Injectable()
export class FormProvider {
  jsonRequest = [];
  validator: RegExp;
  
  constructor(private http: HttpMapper) {}

  buildBodyRequest(json: any, fields, optionsSelect): any {
    let resul = [];
    for (let key in fields) {
      let index = fields[key].Fields.length > 1 ? optionsSelect[key] : 0;
      let id = fields[key].Fields[index].Id;
      resul.push({ Id: id, Value: this.jsonRequest[id] });
    }
    return { Values: resul };
  }

  validateForm(fields, optionsSelect, jsonRequest): boolean {
    this.jsonRequest = jsonRequest;
    let isValidForm = true;
    let i = 0;
    while (fields.length > i && isValidForm) {
      isValidForm = this.isValidField(fields[i]['Fields'], i, optionsSelect);
      i++;
    }
    return !isValidForm;
  }

  isValidField(field: any, position: number, optionsSelect): boolean {
    let isValidField = false;
    let i = field.length > 1 ? optionsSelect[position] : 0;
    if (typeof i != 'undefined') {
      let jsonvalue = this.jsonRequest[field[i].Id];      
      if (typeof jsonvalue != 'undefined' && jsonvalue !== '') {
        if (field[i].Validator){
          this.validator = new RegExp(field[i].Validator);
          isValidField = this.validator.test(jsonvalue);
        } else {
          isValidField = true;
        }
      } else if (field[i].Type == 'boolean' && typeof jsonvalue == 'undefined') {
        this.jsonRequest[field[i].Id] = false; // default Value
        isValidField = true;
      }
    }
    return isValidField;
  }
  
  toFormGroup(fields: FieldModel[]) {
    let group: any = {};

    fields.forEach(field => {
      group[field.FieldId] = field.FieldValidations.length > 0 ? 
                              new FormControl(field.Value || '', Validators.compose(field.FieldValidations)) :
                              new FormControl(field.Value || '')
    });

    return new FormGroup(group);
  }

  getOptionsFields(fieldId: number | string, parentValue?: any): Observable<any> {
    return parentValue ? this.http.get(APP_CONFIG.API_URL + 'api/DynamicForms/RequiredFields/' + fieldId + '?parentValue=' + parentValue) :
                         this.http.get(APP_CONFIG.API_URL + 'api/DynamicForms/RequiredFields/' + fieldId);
  }
}



// WEBPACK FOOTER //
// ./src/providers/myria/form-provider.ts